import type { PickupTime } from '~/declaration/bops';
import type { ATBBopsAvailability } from '../types';

export const bopsPickupMessagging = ({
  inStorePickupEligibility = false,
  curbsidePickupEligibility = false,
  deliveryDay,
  otherDate,
  pickupOptions = [],
  curbsideCutOffTime,
  cutOffTime,
  availability,
}: {
  inStorePickupEligibility?: boolean;
  curbsidePickupEligibility?: boolean;
  deliveryDay: string;
  otherDate?: string;
  pickupOptions?: string[];
  curbsideCutOffTime: PickupTime;
  cutOffTime: PickupTime;
  availability: ATBBopsAvailability;
}) => {
  const bopsLinkTagMessage = ['In Store:', 'NA', '-', 'Curbside:', 'NA']; // 1st and 4th index are dynamic part of tagging message
  const deliveryDayLower = deliveryDay ? deliveryDay.toLowerCase() : '';
  if (pickupOptions && pickupOptions.length > 1 && otherDate) {
    const curbSideAvailableDay = curbsideCutOffTime?.pickupRelativeDay?.toLowerCase();
    const inStoreAvailableDay = cutOffTime?.pickupRelativeDay?.toLowerCase();

    if (pickupOptions[0].toLowerCase() === 'in store') {
      bopsLinkTagMessage[1] = deliveryDayLower === 'today' || deliveryDayLower === 'tomorrow' ? deliveryDay : 'OTHER';
      bopsLinkTagMessage[4] = curbSideAvailableDay ? curbSideAvailableDay.toUpperCase() : 'NA'; // pass NA if value coming in undefined
    } else {
      bopsLinkTagMessage[1] = inStoreAvailableDay ? inStoreAvailableDay.toUpperCase() : 'NA';
      bopsLinkTagMessage[4] = deliveryDayLower === 'today' || deliveryDayLower === 'tomorrow' ? deliveryDay : 'OTHER';
    }
  } else if (pickupOptions && pickupOptions.length > 1) {
    // Both In Store and Curbside pickup are enabled - available same day
    const tagDeliveryDay = deliveryDayLower === 'today' || deliveryDayLower === 'tomorrow' ? deliveryDay : 'OTHER';
    bopsLinkTagMessage[1] = tagDeliveryDay;
    bopsLinkTagMessage[4] = tagDeliveryDay;
  } else if (pickupOptions) {
    if (pickupOptions[0] && pickupOptions[0].toLowerCase() === 'in store') {
      // only instore available
      bopsLinkTagMessage[1] = deliveryDayLower === 'today' || deliveryDayLower === 'tomorrow' ? deliveryDay : 'OTHER';
    } else {
      // only curbside available
      bopsLinkTagMessage[4] = deliveryDayLower === 'today' || deliveryDayLower === 'tomorrow' ? deliveryDay : 'OTHER';
    }
  }
  const { bopsAvailable } = availability;
  bopsLinkTagMessage[1] = inStorePickupEligibility ? bopsLinkTagMessage[1] : 'NA';
  bopsLinkTagMessage[4] = curbsidePickupEligibility ? bopsLinkTagMessage[4] : 'NA';
  const bopsLinkTagMessageResult = bopsAvailable ? bopsLinkTagMessage.join('') : undefined;

  return bopsLinkTagMessageResult;
};
